export default __webpack_public_path__ + "static/305-57e0e3d4b914cedf3695a3d17dbf7feb.gif";